import { RouteRecordRaw } from 'vue-router';

// 구 경로 → 신 경로 하위호환 redirect.
// flat 재편으로 K8s 화면 URL이 모두 바뀌었다. 사용자 북마크·공유 링크·구 workload 개별 경로가
// NOT_FOUND로 떨어지지 않도록 구 경로를 신 경로로 forward한다. 메뉴에는 노출하지 않으므로
// kubernetesMenu가 아닌 이 배열로 두고 라우터에만 등록한다(getKubernetesNaviMenu 대상 아님).
// 경로가 그대로인 화면(pod·node·namespace·container·cluster·storage)은 redirect가 불필요하다.
// NOTE: 한 배포 주기 하위호환용. 다음 주기에 이 파일과 index.ts 등록을 함께 제거한다.
const LEGACY_KUBERNETES_REDIRECTS: Record<string, string> = {
  '/kubernetes/trendAnalysis': '/kubernetes/trend-analysis',
  '/kubernetes/clusterTopology': '/kubernetes/cluster-topology',
  '/kubernetes/objectTopology': '/kubernetes/object-topology',
  '/kubernetes/metadata/cluster-resource-inventory': '/kubernetes/cluster-resource-inventory',
  '/kubernetes/resource/workload': '/kubernetes/workload',
  '/kubernetes/resource/deployments': '/kubernetes/workload?type=deployments',
  '/kubernetes/resource/statefulSets': '/kubernetes/workload?type=statefulSets',
  '/kubernetes/resource/daemonSets': '/kubernetes/workload?type=daemonSets',
  '/kubernetes/resource/replicaSets': '/kubernetes/workload?type=replicaSets',
  '/kubernetes/resource/hpa': '/kubernetes/hpa',
  '/kubernetes/resource/jobs': '/kubernetes/job',
  '/kubernetes/resource/cronJobs': '/kubernetes/cron-job',
  '/kubernetes/network/serviceMap': '/kubernetes/service-map',
  '/kubernetes/network/service': '/kubernetes/service',
  '/kubernetes/network/ingress': '/kubernetes/ingress',
  '/kubernetes/network/ingressController': '/kubernetes/ingress-controller',
  '/kubernetes/network/openshift/route': '/kubernetes/route',
  '/kubernetes/configStorage/configMaps': '/kubernetes/config-map',
  '/kubernetes/configStorage/persistentVolumesClaims': '/kubernetes/persistent-volume-claim',
  '/kubernetes/configStorage/persistentVolumes': '/kubernetes/persistent-volume',
  '/kubernetes/configStorage/storageClasses': '/kubernetes/storage-class',
  '/kubernetes/accessControl/roles': '/kubernetes/role',
  '/kubernetes/accessControl/rolesBindings': '/kubernetes/role-binding',
  '/kubernetes/accessControl/clusterRoles': '/kubernetes/cluster-role',
  '/kubernetes/accessControl/clusterRolesBindings': '/kubernetes/cluster-role-binding',
  '/kubernetes/accessControl/serviceAccounts': '/kubernetes/service-account',
};

export const kubernetesLegacyRedirects: RouteRecordRaw[] = Object.entries(
  LEGACY_KUBERNETES_REDIRECTS,
).map(([from, to]) => {
  const [toPath, queryString] = to.split('?');
  return {
    path: from,
    redirect: queryString
      ? { path: toPath, query: Object.fromEntries(new URLSearchParams(queryString)) }
      : toPath,
  };
});
